import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

export type PhoneNumber0 = z.infer<typeof schemas.PhoneNumber0>

export interface IPhoneNumberCreate {
  phone: string
  extension: string
}

export const phoneComponents = (ph: string): [string, string] => {
  const [phone, extension = ''] = ph.split('x')
  return [phone.replace(/\D/g, ''), extension.replace(/\D/g, '')]
}

export const phoneInvalid = (phone: string): boolean => phone !== '' && !phoneValid(phone)

export const phoneValid = (phone: string): boolean => phone.replace(/\D/g, '').length === 10
